import React from 'react';

import GeneralAssemblyManager from '../../components/Analyzing/GeneralAssemblyManager';

function GeneralAssemblyManagerView() {
  return (
    <GeneralAssemblyManager />
  );
}

export default GeneralAssemblyManagerView;
